import { render } from "./BlFormFieldPhone.vue?vue&type=template&id=a28350c0&scoped=true"
import script from "./BlFormFieldPhone.vue?vue&type=script&lang=js"
export * from "./BlFormFieldPhone.vue?vue&type=script&lang=js"

import "./BlFormFieldPhone.vue?vue&type=style&index=0&id=a28350c0&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28350c0"]])

export default __exports__